import {
  useEffect,
  useRef,
  useState
} from 'react'
import {
  useDispatch,
  useSelector
} from 'react-redux'
import {
  Box,
  Button,
  Skeleton,
  Text
} from '@chakra-ui/react'
import { COLORS } from 'utils/styles'
import { ImagesPng } from 'assets/images'
import {
  getComments,
  getEngagementItems,
  getPosts,
  lastSeenEngagement,
  setBlogParent,
  setBlogRepostData,
  setBlogRepostParent,
  setChosenNotifBlog,
  setCloseAllDrawers,
  setComments,
  setFromEngagementPanel,
  setGetEngagementItemsStatus,
  setHideNotification,
  setOpenPopupBlogs,
  setPosts,
  setProfileItemId,
  showCurrentChatFriendMarkerCoordinate,
  subscribeToProfile,
  usersSelectors
} from 'store'
import { LoadingSpinier } from 'common/Loading'
import {
  AnimatePresence,
  motion
} from 'framer-motion'
import {
  ENGAGEMENT_TYPES,
  PENDING,
  SUCCEEDED
} from 'utils/constants'
import {
  convertToOwnTimeZone,
  differenceInMS,
  engagementTimeFormat,
  isNotMobile
} from 'utils/helpers'
import { SavedBlogs } from './SavedBlogs'
import {
  StyledImage,
  StyledSubText
} from './styled'

const MotionBox = motion(Box)

export const EngagementItemList = () => {
  const groups = {
    Recent: [],
    Today: [],
    Yesterday: []
  }

  const dispatch = useDispatch()
  const [loadSubsId, setLoadSubsId] = useState(0)
  const [loadedProfileImage, setLoadedProfileImage] = useState({})
  const [loadedPostImage, setLoadedPostImage] = useState({})
  const [oldItemsCount, setOldItemsCount] = useState(0)
  const [loadingMore, setLoadingMore] = useState(false)
  const [now, setNow] = useState(Date.now())
  const observer = useRef()
  const secondToLastItem = useRef(null)
  const itemCountPerBatch = Math.ceil(window.innerHeight / 80)

  const {
    activeProfile,
    engagementItems,
    getEngagementItemsStatus,
    lastIdForEngagement,
    lastIdForComment,
    lastIdForPost,
    posts,
    selectedEngagementType,
    subscribeToProfileStatus
  } = useSelector(usersSelectors)

  const closeAllModals = () => {
    dispatch(setCloseAllDrawers(true))
    setTimeout(() => dispatch(setCloseAllDrawers(false)), 850)
  }

  const handleProfileImage = (postId) => {
    setTimeout(() => {
      setLoadedProfileImage((prev) => ({
        ...prev,
        [postId]: true
      }))
    }, 500)
  }

  const handlePostImage = (postId) => {
    setTimeout(() => {
      setLoadedPostImage((prev) => ({
        ...prev,
        [postId]: true
      }))
    }, 500)
  }

  const goToMarker = (item) => {
    closeAllModals()

    dispatch(setProfileItemId(''))

    setTimeout(() => {
      dispatch(showCurrentChatFriendMarkerCoordinate({
        coord: item?.coordinates,
        isStatic: true
      }))
      sessionStorage.setItem('openProfileAfterAnimation', item?.profile_id)
    }, 850)
  }

  const headerContent = (item) => {
    if (
      ENGAGEMENT_TYPES.likes === selectedEngagementType
      || ENGAGEMENT_TYPES.comments === selectedEngagementType
      || ENGAGEMENT_TYPES.reposts === selectedEngagementType
      || ENGAGEMENT_TYPES.shares === selectedEngagementType
    ) {
      return item?.post_title ?? item?.comment_body
    }

    if (ENGAGEMENT_TYPES.subscriptions === selectedEngagementType) {
      return activeProfile?.full_name
    }

    return ''
  }

  const bodyContent = (item) => {
    if (ENGAGEMENT_TYPES.likes === selectedEngagementType) {
      return item.full_name + ' liked your ' + (item.type === 'post' ? 'article' : 'comment')
    }

    if (ENGAGEMENT_TYPES.comments === selectedEngagementType) {
      return item.full_name + ': ' + item.body
    }

    if (ENGAGEMENT_TYPES.reposts === selectedEngagementType) {
      return item.full_name + ' reposted this'
    }

    if (ENGAGEMENT_TYPES.shares === selectedEngagementType) {
      return item.full_name + ' shared this'
    }

    if (ENGAGEMENT_TYPES.subscriptions === selectedEngagementType) {
      return item?.full_name + ' subscribed to you'
    }

    return ''
  }

  const openPost = (item, part) => {
    dispatch(setBlogRepostData([]))
    dispatch(setBlogRepostParent([]))

    const notifDrawer = document.querySelector('#notification-drawer-header')
    let postOrComment = ''
    if (selectedEngagementType === ENGAGEMENT_TYPES.comments) {
      postOrComment = part === 'middle' ? 'comment' : 'post'
    } else {
      postOrComment = item?.type === 'comment' && part === 'middle' ? 'comment' : 'post'
    }

    let waitTime = 0
    if (isNotMobile() && notifDrawer && notifDrawer.offsetWidth * 3 >= document.querySelector('body').offsetWidth) {
      dispatch(setHideNotification(true))
      waitTime = 900
    }

    setTimeout(() => {
      dispatch(setChosenNotifBlog([]))
      dispatch(setBlogParent([]))
      dispatch(setComments([]))
      dispatch(setFromEngagementPanel({
        clicked: true,
        type: postOrComment
      }))

      let postOpen = false
      if (
        postOrComment === 'comment'
        && posts.length
        && parseInt(posts[0].id, 10) === parseInt(item?.post_id, 10)
      ) {
        postOpen = true
        document.querySelector('#hiddenItem').scrollIntoView({ behavior: 'instant', block: 'start' })
      } else {
        dispatch(setPosts([]))
        dispatch(getPosts({
          type: 'single',
          postId: item?.post_id,
          id: activeProfile?.id
        }))
      }

      if (postOrComment === 'comment') {
        const values = Object.values(item?.path)
        const commentDeets = values[values.length - 1]

        dispatch(setBlogParent([
          ...postOpen ? [posts[0]] : [],
          ...Object.values(item.path)
        ]))

        if (posts.length) {
          dispatch(getComments({
            type: item.parent_type,
            forceGet: item?.id,
            ...(item.parent_type === 'post' ? { post_id: item.post_id } : { comment_id: commentDeets?.comment_id })
          }))
        } else {
          setTimeout(() => {
            dispatch(getComments({
              type: item.parent_type,
              forceGet: item?.id,
              ...(item.parent_type === 'post' ? { post_id: item.post_id } : { comment_id: commentDeets?.comment_id })
            }))
          }, 1050)
        }
      }

      dispatch(setOpenPopupBlogs(true))
    }, waitTime)
  }

  const groupByTime = (items) => {
    items.forEach((item, index) => {
      const diffInMS = differenceInMS(convertToOwnTimeZone(item.created_at))

      if (diffInMS > -3600000) {
        groups.Recent.push({
          ...item,
          index
        })
      } else if (diffInMS > -86400000) {
        groups.Today.push({
          ...item,
          index
        })
      } else {
        groups.Yesterday.push({
          ...item,
          index
        })
      }
    })

    return groups
  }
  const grouped = engagementItems ? groupByTime(engagementItems) : {}

  const subscribeBtn = (item) => {
    if (
      subscribeToProfileStatus === PENDING
      && loadSubsId === item?.profile_id
    ) {
      return (
        <LoadingSpinier
          width="12px"
          height="12px"
          marginTop="3px"
        />
      )
    }

    if (item?.isSubscribed) {
      return 'Unsubscribe'
    }

    return 'Subscribe'
  }

  const rightImage = (item) => {
    if (ENGAGEMENT_TYPES.subscriptions === selectedEngagementType) {
      return activeProfile?.profile_picture ?? ImagesPng.ProfileImage
    }

    return item.post_image ?? ImagesPng.PlaceholderSquare
  }

  useEffect(() => {
    setTimeout(() => {
      observer.current = new IntersectionObserver((entries) => {
        if (
          entries[0].isIntersecting && engagementItems.length - oldItemsCount >= itemCountPerBatch
        ) {
          observer.current.unobserve(secondToLastItem.current)
          setLoadingMore(true)
          setOldItemsCount(engagementItems.length)
          dispatch(getEngagementItems({
            type: selectedEngagementType,
            limit: itemCountPerBatch,
            ...(
              ENGAGEMENT_TYPES.likes === selectedEngagementType
              || ENGAGEMENT_TYPES.comments === selectedEngagementType
                ? {
                  lastIdForPost,
                  lastIdForComment
                }
                : { lastId: lastIdForEngagement }
            ),
            ...(
              ENGAGEMENT_TYPES.reposts === selectedEngagementType && {
                lastDateTime: engagementItems.at(-1).created_at,
                lastId: engagementItems.at(-1).post_id
              }
            )
          }))
        }
      })

      const currentObserver = observer.current
      if (secondToLastItem.current && engagementItems.length - oldItemsCount >= itemCountPerBatch) {
        currentObserver.observe(secondToLastItem.current)
      }

      setLoadingMore(false)

      return () => {
        if (secondToLastItem.current) {
          observer.current.disconnect()
        }
      }
    }, 1000)
  }, [engagementItems])

  useEffect(() => {
    if (getEngagementItemsStatus === SUCCEEDED) {
      dispatch(setGetEngagementItemsStatus(0))
    }
  }, [getEngagementItemsStatus])

  useEffect(() => {
    dispatch(lastSeenEngagement({ type: selectedEngagementType }))
  }, [])

  useEffect(() => {
    // This is only used to automatically update the timestamps
    const interval = setInterval(() => setNow(Date.now()), 10000)
    return () => clearInterval(interval)
  }, [])

  return (
    <MotionBox
      key="main"
      initial={{ x: 450 }}
      animate={{ x: 0 }}
      transition={{
        type: 'spring',
        duration: 0.8
      }}
    >
      <AnimatePresence initial={false}>
        {
          engagementItems.length
            ? Object.entries(grouped).map(([key, items]) => (
              items.length
                ? (
                  <MotionBox
                    key={key}
                    initial={{ height: 0 }}
                    animate={{ height: 'auto' }}
                    exit={{
                      height: 0
                    }}
                    transition={{
                      ease: [0, 0.2, 0.6, 1],
                      duration: 0.8
                    }}
                    transformOrigin="top"
                    backgroundColor={COLORS.white}
                    position="relative"
                    overflow="hidden"
                  >
                    <Box
                      fontWeight="bold"
                      fontSize="17px"
                      color={COLORS.darkGray}
                      border="solid 1px black"
                      borderTop={
                        key === 'Recent'
                        || (
                          key === 'Today'
                          && !groups.Recent.length
                        )
                        || (
                          key === 'Yesterday'
                          && !groups.Recent.length
                          && !groups.Today.length
                        )
                          ? 'solid 2px black'
                          : 'solid 1px black'
                      }
                      borderRadius="5px"
                      borderBottom={key === 'Yesterday' && !items.length ? 'solid 2px black' : 'solid 1px black'}
                      paddingLeft="20px"
                      backgroundColor={COLORS.gray}
                    >
                      {key}
                    </Box>

                    {
                      ENGAGEMENT_TYPES.saves === selectedEngagementType
                        ? (
                          <SavedBlogs
                            engagementItems={engagementItems}
                            engagementTimeFormat={engagementTimeFormat}
                            items={items}
                            goToMarker={goToMarker}
                            openPost={openPost}
                            secondToLastItem={secondToLastItem}
                          />
                        )
                        : items.map((item) => (
                          <MotionBox
                            ref={
                              item.index === engagementItems.length - 2
                                ? secondToLastItem
                                : null
                            }
                            initial={{ height: 0 }}
                            animate={{ height: 'auto' }}
                            exit={{ height: 0 }}
                            transition={{
                              ease: [0, 0.2, 0.6, 1],
                              duration: 0.8
                            }}
                            transformOrigin="top"
                            overflow="hidden"
                            key={item.index}
                          >
                            <Box
                              display="flex"
                              justifyContent="space-between"
                              backgroundColor={COLORS.white}
                              border="solid black 1px"
                              borderBottomRadius={
                                item.index === engagementItems.length - 1
                                && engagementItems.length - 1 >= itemCountPerBatch
                                  ? '10px'
                                  : ''
                              }
                              cursor="pointer"
                            >
                              <Box
                                onClick={(e) => {
                                  e.stopPropagation()

                                  goToMarker({
                                    profile_id: item.profile_id,
                                    coordinates: item.coordinates
                                  })
                                }}
                              >
                                <Skeleton
                                  isLoaded={loadedProfileImage[item.post_id]}
                                  fadeDuration={1}
                                  width="66px"
                                  height="66px"
                                  margin="5px"
                                  borderRadius="5px"
                                >
                                  <StyledImage
                                    src={item.profile_picture ?? ImagesPng.ProfileImage}
                                    onLoad={() => handleProfileImage(item.post_id)}
                                  />
                                </Skeleton>
                              </Box>

                              <Box
                                as="button"
                                flex="1"
                                width="100%"
                                minWidth="0px"
                                cursor={ENGAGEMENT_TYPES.subscriptions === selectedEngagementType ? 'default' : 'pointer'}
                                onClick={() => {
                                  if (ENGAGEMENT_TYPES.subscriptions !== selectedEngagementType) {
                                    openPost(item, 'middle')
                                  }
                                }}
                              >
                                <Box
                                  textAlign="center"
                                  background={COLORS.lightGoldGradientLeftToRight}
                                  borderRadius="5px"
                                  marginTop="5px"
                                  fontSize="16px"
                                  padding="0 20px"
                                >
                                  <Text
                                    textOverflow="ellipsis"
                                    overflow="hidden"
                                    whiteSpace="nowrap"
                                  >
                                    {headerContent(item)}
                                  </Text>
                                </Box>
                                <Box
                                  display={ENGAGEMENT_TYPES.subscriptions === selectedEngagementType ? 'flex' : 'block'}
                                  alignItems="center"
                                  justifyContent="space-between"
                                >
                                  <Box
                                    flex="1"
                                    minWidth="0"
                                  >
                                    <StyledSubText>{bodyContent(item)}</StyledSubText>
                                    <StyledSubText>
                                      {engagementTimeFormat(item.created_at)}
                                    </StyledSubText>
                                  </Box>

                                  {
                                    ENGAGEMENT_TYPES.subscriptions === selectedEngagementType
                                      ? (
                                        <Button
                                          onClick={(e) => {
                                            e.stopPropagation()

                                            setLoadSubsId(item?.profile_id)
                                            dispatch(subscribeToProfile({
                                              subscribeId: item?.profile_id
                                            }))
                                          }}
                                          width="80px"
                                          height="38px"
                                          fontSize="15px"
                                          fontWeight="400"
                                          letterSpacing="-1px"
                                          backgroundColor={COLORS.gold_hover}
                                          background={COLORS.lightGoldGradientLeftToRight}
                                          border="solid 1px black"
                                          flexShrink="0"
                                          _hover={{
                                            background: COLORS.gold_hover
                                          }}
                                          pointerEvents={subscribeToProfileStatus === PENDING ? 'none' : 'auto'}
                                        >
                                          {subscribeBtn(item)}
                                        </Button>
                                      ) : ''
                                  }
                                </Box>
                              </Box>

                              <Box
                                onClick={() => {
                                  if (ENGAGEMENT_TYPES.subscriptions === selectedEngagementType) {
                                    goToMarker({
                                      profile_id: activeProfile.id,
                                      coordinates: activeProfile.coordinates
                                    })
                                  } else {
                                    openPost(item, 'right')
                                  }
                                }}
                              >
                                <Skeleton
                                  isLoaded={loadedPostImage[item.post_id]}
                                  fadeDuration={1}
                                  width="66px"
                                  height="66px"
                                  margin="5px"
                                  borderRadius="5px"
                                >
                                  <StyledImage
                                    src={rightImage(item)}
                                    onLoad={() => handlePostImage(item.post_id)}
                                  />
                                </Skeleton>
                              </Box>
                            </Box>
                          </MotionBox>
                        ))
                    }
                  </MotionBox>
                ) : ''
            )) : (
              <Box
                alignItems="center"
                backgroundColor="rgb(229, 229, 229)"
                borderRadius="3px"
                border="solid 1px black"
                margin="5% 2% !important"
                padding="5% 10%"
              >
                <Text
                  textAlign="center"
                  whiteSpace="pre-line"
                >
                  No Engagements Yet
                </Text>
              </Box>
            )
        }
      </AnimatePresence>
      {
        loadingMore && getEngagementItemsStatus === PENDING
          ? (
            <Box margin="75px 0 75px 0">
              <LoadingSpinier />
            </Box>
          ) : ''
      }
    </MotionBox>
  )
}
